module.exports = __webpack_public_path__ + "img/81ed71f127f8978386b87d0d4d911c40.28f0e522.png";